import React, { memo, useCallback } from "react";
import MoonLoader from "react-spinners/MoonLoader";
import Swal from "sweetalert2";
import NoteItem from "./NoteItem";
import NoteForm from "./NoteForm";
import { useContactNotes } from "../../hooks";
import "./NotesSection.css";

/**
 * Seção de notas do contato
 */
const NotesSection = memo(({ contactId }) => {
  const {
    notes,
    pinnedNotes,
    regularNotes,
    isLoading,
    isCreating,
    createNote,
    deleteNote,
    togglePinNote,
  } = useContactNotes(contactId);

  // Criar nota
  const handleCreateNote = useCallback(async (noteData) => {
    await createNote(noteData);
  }, [createNote]);

  // Excluir nota com confirmação
  const handleDeleteNote = useCallback(async (note) => {
    const result = await Swal.fire({
      title: "Excluir nota?",
      text: "Esta ação não pode ser desfeita.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Excluir",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      await deleteNote(note.id);
    }
  }, [deleteNote]);

  // Toggle pin
  const handleTogglePin = useCallback(async (note) => {
    await togglePinNote(note.id);
  }, [togglePinNote]);

  if (isLoading) {
    return (
      <div className="sc-notes-section sc-notes-section--loading">
        <MoonLoader size={24} color="#3b82f6" />
        <span>Carregando notas...</span>
      </div>
    );
  }

  return (
    <div className="sc-notes-section">
      {/* Formulário para nova nota */}
      <NoteForm onSubmit={handleCreateNote} isSubmitting={isCreating} />

      {/* Lista de notas */}
      <div className="sc-notes-section__list">
        {notes.length === 0 ? (
          <div className="sc-notes-section__empty">
            <span className="sc-notes-section__empty-icon">📝</span>
            <span>Nenhuma nota para este contato</span>
          </div>
        ) : (
          <>
            {/* Notas fixadas */}
            {pinnedNotes.length > 0 && (
              <div className="sc-notes-section__group">
                <h4 className="sc-notes-section__group-title">Fixadas</h4>
                {pinnedNotes.map((note) => (
                  <NoteItem
                    key={note.id}
                    note={note}
                    onTogglePin={handleTogglePin}
                    onDelete={handleDeleteNote}
                  />
                ))}
              </div>
            )}

            {/* Notas regulares */}
            {regularNotes.length > 0 && (
              <div className="sc-notes-section__group">
                {pinnedNotes.length > 0 && (
                  <h4 className="sc-notes-section__group-title">Outras notas</h4>
                )}
                {regularNotes.map((note) => (
                  <NoteItem
                    key={note.id}
                    note={note}
                    onTogglePin={handleTogglePin}
                    onDelete={handleDeleteNote}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
});

NotesSection.displayName = "NotesSection";

export default NotesSection;
